import * as React from 'react'

import Avatar from 'common/Avatar/Avatar'
import Styles from './MiniDocCard.module.scss'
import { AlgoliaArticle } from 'types'
import { Link } from 'react-router-dom'
import { ReactComponent as DocEmoji } from 'assets/icons/document24.svg'

interface Props {
  article: AlgoliaArticle
  className?: string
  variant?: string
  onClick?: (e: React.MouseEvent, article: AlgoliaArticle) => void
}

export function MiniDocCardBody({ className, article, variant = '' }: Props) {
  return (
    <div className={`${Styles.container} ${className} ${Styles[variant]}`}>
      <div
        className={Styles.coverImage}
        style={
          article.cover_image_url
            ? {
                background: `url(${article.cover_image_url})`,
              }
            : undefined
        }
      />
      <Avatar
        className={Styles.emoji}
        emoji={article.header_emoji ?? <DocEmoji className="docEmoji" />}
        size={variant === 'templatePickerSlider' ? 32 : 48}
        color="white"
      />

      <div className={Styles.lowerContainer}>
        <h2>{article.title}</h2>
        <div className={Styles.counterContainer}>
          <div className={Styles.cloutCounter}>
            <span className={Styles.bold}>{article.copies_count}</span> copies
          </div>
        </div>
      </div>
    </div>
  )
}

const MiniDocCard = ({ article, className, onClick }: Props) => {
  return (
    <Link
      to={`/docs/${article.seo_string}`}
      onClick={(e) => {
        if (onClick) {
          onClick(e, article)
        }
      }}
    >
      <MiniDocCardBody className={className} article={article} />
    </Link>
  )
}

export default MiniDocCard
